import { Box, styled } from '@mui/material';

const Indicator = styled(Box)<{ delay: number }>(({ theme, delay }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 6,
  fontSize: '0.65rem',
  letterSpacing: '0.14em',
  color: theme.palette.text.secondary,
  padding: '2px 6px',
  border: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.background.default,

  /* start powered off */
  opacity: 0.4,

  animation: `indicatorBoot 0.8s ease-out forwards`,
  animationDelay: `${delay}ms`,

  '@keyframes indicatorBoot': {
    from: {
      opacity: 0.3,
    },
    to: {
      opacity: 1,
    },
  },
}));

const Led = styled('span')<{ color?: string }>(({ theme, color }) => ({
  width: 8,
  height: 8,
  borderRadius: '50%',
  backgroundColor: color || theme.palette.primary.main,
  boxShadow: `0 0 6px ${color || theme.palette.primary.main}`,
  opacity: 0,

  animation: 'ledOn 0.6s ease-out forwards',

  '@keyframes ledOn': {
    from: {
      opacity: 0,
      boxShadow: 'none',
    },
    to: {
      opacity: 1,
    },
  },
}));

export const IndicatorLight = ({
  label,
  color,
  delay,
}: {
  label: string;
  color?: string;
  delay: number;
}) => {
  return (
    <Indicator delay={delay}>
      <Led color={color} />
      {label}
    </Indicator>
  );
};
